<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,11C13,11,15,11,15,11C15,11,15,5,15,5C15,5,13,5,13,5C13,5,13,11,13,11C13,11,13,11,13,11ZM3,5C3,5,1,5,1,5C1,5,1,11,1,11C1,11,3,11,3,11C3,11,3,5,3,5C3,5,3,5,3,5ZM14,4C15.1,4,16,3.1,16,2C16,0.9,15.1,0,14,0C12.9,0,12,0.9,12,2C12,3.1,12.9,4,14,4C14,4,14,4,14,4ZM2,12C0.9,12,0,12.9,0,14C0,15.1,0.9,16,2,16C3.1,16,4,15.1,4,14C4,12.9,3.1,12,2,12C2,12,2,12,2,12ZM14,12C12.9,12,12,12.9,12,14C12,15.1,12.9,16,14,16C15.1,16,16,15.1,16,14C16,12.9,15.1,12,14,12C14,12,14,12,14,12ZM5,3C5,3,11,3,11,3C11,3,11,1,11,1C11,1,5,1,5,1C5,1,5,3,5,3C5,3,5,3,5,3ZM2,0C0.9,0,0,0.9,0,2C0,3.1,0.9,4,2,4C3.1,4,4,3.1,4,2C4,0.9,3.1,0,2,0C2,0,2,0,2,0ZM5,15C5,15,11,15,11,15C11,15,11,13,11,13C11,13,5,13,5,13C5,13,5,15,5,15C5,15,5,15,5,15Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Widget',
} as DefineComponent
</script>
